import { createContext } from 'react';

export const TextDeviceCotext = createContext({
  allDevice: [],
  allParameter: [],
  refresh_ContextDevice: () => {},
});
